export class FiltroIncentivoBicicletaModel{
    public documentoONombre: string;
	public tipoDocumentoJefe: string;
	public numDocumentoJefe: string;
	public sede: string;
	public dependencia: string;
	public estado: string;
	

}